import { message } from "antd";
import { AxiosError } from "axios";

// A 403 reaching here is a permission denial, not a dead session. The backend returns 403 for a bad
// token too (SessionAuthentication is its first auth class), but the response interceptors
// (index.tsx, tokenRefresh.ts) already handle that: they refresh and retry, and send the user to
// /login only when the refresh fails. A 403 that survives the retry came back with a fresh token,
// so redirecting here would log a signed-in user out over e.g. "Not permitted to change permissions."
export function errorActions(errors: AxiosError, msg: string) {
  const responseBody = errors?.response?.data as any;
  if (responseBody?.message) {
    return message.error(responseBody.message);
  }
  if (responseBody?.error) {
    return message.error(responseBody.error);
  }
  if (responseBody?.detail) {
    return message.error(responseBody.detail);
  }
  if (errors?.response?.status == 403) {
    return message.error("You don't have permission to do this.");
  }
  return message.error(msg);
}
